import styled, { keyframes } from 'styled-components';

export const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateX(50px); }
  10% { opacity: 1; transform: translateX(0); }
  90% { opacity: 1; transform: translateX(0); }
  100% { opacity: 0; transform: translateX(-50px); }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  width: 100%;
`;

export const MessageContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  text-align: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  overflow: hidden;
  height: 50px;
`;

export const Message = styled.div`
  position: absolute;
  width: 100%;
  animation: ${fadeInOut} 4s linear infinite;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${(props) => props.progress}%;
  background: linear-gradient(90deg, ${({ theme }) => theme.colors.primary.main} 0%, ${({ theme }) => theme.colors.primary.dark} 100%);
  border-radius: 4px;
  transition: width 0.3s ease-out;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 100%
    );
    animation: shimmer 2s infinite;
  }
  
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

export const ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: rgba(255, 255, 255, 0.8);
`;

export const PhaseLabel = styled.p`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  animation: ${fadeInOut} 4s linear infinite;
`;

export const ProgressPercentage = styled.p`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.primary.main};
`;
